var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.internalError)?_c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('Login'),_vm._v(" "),_c('PasswordRecovery'),_vm._v(" "),_c('Notifications'),_vm._v(" "),_c('el-backtop')],1):_c('InternalServerError')
}
var staticRenderFns = []

export { render, staticRenderFns }